import { render, staticRenderFns } from "./DashboardUser.vue?vue&type=template&id=06abd0d2&"
import script from "./DashboardUser.vue?vue&type=script&lang=js&"
export * from "./DashboardUser.vue?vue&type=script&lang=js&"
import style0 from "./DashboardUser.vue?vue&type=style&index=0&id=06abd0d2&prod&lang=css&"
import style1 from "./DashboardUser.vue?vue&type=style&index=1&id=06abd0d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports